module.exports = __webpack_public_path__ + "img/vide6.9c928e7c.png";